import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Page from './page';

// Get Remote config for sh_trackers_config from window
const getTrackersConfig = () => (window && window.shTrackersConfig) || {};

/**
 *  Check is new node module based refund tracker is enabled globally
 * @returns {*}
 */
export const isRefundTrackerEnabledGlobally = () => {
  const trackersConfig = getTrackersConfig();
  if (!_isEmpty(trackersConfig.refunds)) {
    return trackersConfig.refunds.enableGlobally || false;
  }
  return false;
};

/**
 *  Common function to validate is the market is part of remote config or not.
 * @param markets
 * @returns {boolean}
 */
const isMarketPartOfTheRC = (markets) => {
  if (!_isEmpty(markets)) {
    const country = Page.getCountry().toUpperCase();
    const locale = Page.getAPILocalilty();

    return (
      markets
        .split(',')
        .filter((market) => market.indexOf(`${country}:`) >= 0)
        .filter((selectedMarket) => selectedMarket.split(':')[1].indexOf(locale) >= 0).length > 0
    );
  }
  return false;
};

/**
 * Check if market is black listed
 * @returns {boolean}
 */
export const isMarketBlacklisted = () => {
  const trackersConfig = getTrackersConfig();
  const blacklistedMarkets = _get(trackersConfig, 'refunds.blacklistedMarkets');
  return isMarketPartOfTheRC(blacklistedMarkets);
};

/**
 * Check if market is enabled in Remote config if not enabled globally.
 * @returns {boolean}
 */
const isMarketEnabledInRc = () => {
  const trackersConfig = getTrackersConfig();
  const enabledMarkets = _get(trackersConfig, 'refunds.enabledMarkets');
  return isMarketPartOfTheRC(enabledMarkets);
};

/**
 *  check if new refunds tracker is enabled/disabled
 *  1) Check if market is part of blacklistedMarkets. If market is part of blacklist return false else check next conditions.
 *  2) check if market is enabled globally. If enabled globally return true if not check next condition
 *  3) Check if market is part of enabledMarkets. if exists true else false.
 * @returns {boolean}
 */
export const isCsHelpRefundTrackerEnabled = () => {
  if (isMarketBlacklisted()) {
    return false;
  }

  if (isRefundTrackerEnabledGlobally()) {
    return true;
  }

  return isMarketEnabledInRc();
};

/**
 * Get refund alert on lick redirect FaqId from RC.
 * @returns {string}
 */
export const getAlertRedirectFaq = () => {
  const trackersConfig = getTrackersConfig();
  return _get(trackersConfig, 'refunds.alertRedirectFaq', 'FAQ1212');
};

// Check if current article mapped to path is part of topic mapping in RC
const checkIsArticleMappedToTopicInRc = (article, trackerConfig) => {
  const articleMap = article && article.articleMappedTo;
  const breadcrumbTopics = _get(trackerConfig, 'refunds.breadcrumbChecker');
  return (
    typeof articleMap === 'string' &&
    Array.isArray(breadcrumbTopics) &&
    breadcrumbTopics.some((topic) => articleMap.indexOf(topic) >= 0)
  );
};

// Check if current article breadcrumb path is part of topic mapping in RC
const checkIsArticleBreadCrumbMappedToTopicInRc = (article, trackerConfig) => {
  const articleBreadCrumbPath = article && article.breadCrumbPath;
  const breadcrumbTopics = _get(trackerConfig, 'refunds.breadcrumbChecker');
  return (
    typeof articleBreadCrumbPath === 'string' &&
    Array.isArray(breadcrumbTopics) &&
    breadcrumbTopics.some((topic) => articleBreadCrumbPath.indexOf(topic) >= 0)
  );
};

/**
 *  Check if current selected article is enabled in RC to display refund tracker
 * @param article
 * @returns {boolean|*}
 */
export const isArticleMappedToBreadCrumb = (article) => {
  try {
    const trackersConfig = getTrackersConfig();
    return (
      checkIsArticleMappedToTopicInRc(article, trackersConfig) ||
      checkIsArticleBreadCrumbMappedToTopicInRc(article, trackersConfig)
    );
  } catch (e) {
    return false;
  }
};
// ---------------------------------------END of Trackers RC-------------------------------------

// -------------------------------------Refund Tracker Helpers ------------------------------------

// Filter refund transactions with out lifecycles
export const getTransactionsFilteredWithLifeCyclesOnly = (transactions) =>
  Array.isArray(transactions) && transactions.filter((transaction) => !_isEmpty(transaction.lifecycles));

// Check if show EChecks are enabled/disabled
export const isShowECheckTransactions = (configs) => {
  if (configs) {
    return _get(configs, 'csHelpTrackersConfig.refunds.showEChecks', false);
  }
  return false;
};

// Get final transactions.
export const getFinalTransactions = (transactions, configs) => {
  let finalTransactions = [];

  if (Array.isArray(transactions) && transactions.length > 0) {
    // If showEcheck is true return all transactions
    if (isShowECheckTransactions(configs)) {
      finalTransactions = transactions;
    } else {
      // If show ECheck is false. Filter transactions with only lifecycles.
      finalTransactions = getTransactionsFilteredWithLifeCyclesOnly(transactions);
    }

    // Return final transactions with not empty of required fields
    return finalTransactions.filter((transaction) => !_isEmpty(transaction.settlement_date));
  }

  return finalTransactions;
};

// -------------------------------- Disputes Tracker Helper ----------------------
// Check if dispute Alert is enabled in RC
export const isDisputeAlertEnabled = () => {
  const trackersConfig = getTrackersConfig();
  if (!_isEmpty(trackersConfig.disputes)) {
    return trackersConfig.disputes.enableAlert || false;
  }
  return false;
};

// Check if dispute tracker is enabled in RC
export const isDisputeTrackerEnabled = () => {
  const trackersConfig = getTrackersConfig();
  if (!_isEmpty(trackersConfig.disputes)) {
    return trackersConfig.disputes.enableTracker || false;
  }
  return false;
};
